import React from 'react';
import { Icon, IconButton } from 'library';
import { NUMBER_FORMATS } from 'utils/formatters';

import './DebtListItem.scss';

const DebtListItem = ({ debtInfo, onDebtDelete, index }) => {
  const { balance, interestRate, listTitle, icon } = debtInfo;
  return (
    <div className="DebtListItemContainer">
      <div className="DebtListItemIconContainer">
        <Icon name={icon} size="lg" color="#366ced" />
      </div>
      <div className="DebtListItemContentContainer">
        <div>
          <div className="DebtListItemTitle">{listTitle}</div>
          <div className="DebtListItemSmallText">
            Balance: {NUMBER_FORMATS.currency(balance)} · Rate: {NUMBER_FORMATS.percent(interestRate)}
          </div>
        </div>
        <div>
          <IconButton icon="cancel" size="lg" onClick={() => onDebtDelete(index)} />
        </div>
      </div>
    </div>
  );
};

export default DebtListItem;
